import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"

import { connect } from "react-redux"

import { Link } from "react-router-dom"

// Import menuDropdown
// import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

// import megamenuImg from "../../assets/images/megamenu-img.png"
import logo from "../../assets/images/pdflogo.png"
import logoLightPng from "../../assets/images/pdflogo.png"
import logoDark from "../../assets/images/pdflogo.png"

//i18n
import { withTranslation, WithTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"

interface HeaderProps extends WithTranslation {
  changeSidebarType?: (type: string, isMobile?: boolean) => void
  leftMenu?: boolean
  leftSideBarType?: string
  showRightSidebar?: boolean
  showRightSidebarAction?: (isopen: boolean) => { type: string; payload: boolean; }
  toggleLeftmenu?: (isopen: boolean) => { type: string; payload: boolean; }
  toggleMenuCallback?: () => void
}

const Header: React.FC<HeaderProps> = (props) => {
  const [userRole, setUserRole] = useState<string | null>(null)

  useEffect(() => {
    const readRole = () => {
      try {
        const authUser = localStorage.getItem("authUser")
        if (authUser) {
          const obj = JSON.parse(authUser)
          const role = obj.role || obj.type || null
          setUserRole(role ? String(role).trim() : null)
        } else {
          setUserRole(null)
        }
      } catch {
        setUserRole(null)
      }
    }
    readRole()
    window.addEventListener("profileUpdated", readRole)
    window.addEventListener("focus", readRole)
    return () => {
      window.removeEventListener("profileUpdated", readRole)
      window.removeEventListener("focus", readRole)
    }
  }, [])

  // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  function toggleFullscreen() {
    const doc = document as any;
    const docEl = document.documentElement as any;
    if (
      !document.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (docEl.mozRequestFullScreen) {
        docEl.mozRequestFullScreen()
      } else if (docEl.webkitRequestFullscreen) {
        docEl.webkitRequestFullscreen((Element as any).ALLOW_KEYBOARD_INPUT)
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen()
      } else if (doc.webkitCancelFullScreen) {
        doc.webkitCancelFullScreen()
      } else if (doc.cancelFullScreen) {
        doc.cancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body;
    body.classList.toggle("vertical-collpsed");
    body.classList.toggle("sidebar-enable");
  }
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="45" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="45" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logo} alt="" height="10" />
                </span>
                <span className="logo-lg">
                  <img src={logoLightPng} alt="" height="45" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                if (props.toggleMenuCallback) {
                  props.toggleMenuCallback();
                } else {
                  tToggle();
                }
              }}
              className="btn btn-sm px-3 font-size-24 header-item waves-effect vertical-menu-btn"
              id="vertical-menu-btn"
            >
              <i className="mdi mdi-menu"></i>
            </button>


            <Link to="/" className="d-none d-sm-block d-flex align-items-center me-2">
              <span className="badge bg-primary px-3 py-2 text-capitalize align-middle" style={{ fontSize: "0.85rem", lineHeight: 1.25 }}>
                back to Home
              </span>
            </Link>

            <div className="d-none d-sm-block d-flex align-items-center">
              {userRole ? (
                <span className="badge bg-primary px-3 py-2 text-capitalize align-middle" style={{ fontSize: "0.85rem", lineHeight: 1.25 }}>
                  {userRole}
                </span>
              ) : null}
            </div>



            

          </div>
          <div className="d-flex">
            {/* <form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={(props.t as (key: string) => string)("Search") + "..."}
                />
                <span className="fa fa-search"></span>
              </div>
            </form> */}
            {/* <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search)
                }}
                type="button"
                className="btn header-item noti-icon waves-effect"
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div> */}
            {/* <LanguageDropdown /> */}
            <div className="dropdown d-none d-lg-inline-block">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen()
                }}
                className="btn header-item noti-icon waves-effect"
                data-toggle="fullscreen"
              >
                <i className="mdi mdi-fullscreen font-size-24"></i>
              </button>
            </div>
            {/* <NotificationDropdown /> — temporarily hidden */}
            <ProfileMenu />
            <div
              onClick={() => {
                if (props.showRightSidebarAction) {
                  props.showRightSidebarAction(!props.showRightSidebar)
                }
              }}
              className="dropdown d-inline-block"
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
              >
                <i className="mdi mdi-spin mdi-cog"></i>
              </button>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  toggleMenuCallback: PropTypes.func
}

const mapStatetoProps = (state: any) => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
